import React, { useMemo, useState } from 'react';
import { subscribeEmailToKlaviyo } from './klaviyo';
import HeroSection from './HeroSection';
import LeadCaptureSection from './LeadCaptureSection';
import AuthorSection from './AuthorSection';
import InsightsSection from './InsightsSection';
import FinalCtaSection from './FinalCtaSection';
import { createReportAccessToken, unlockReportViewer } from './accessControl';

const MiningReportLanding: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const isValidEmail = useMemo(() => /\S+@\S+\.\S+/.test(email), [email]);

  const submitAndOpenReport = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');

    if (!isValidEmail) {
      setError('Please enter a valid email address.');
      return;
    }

    const accessToken = createReportAccessToken();
    unlockReportViewer();
    const reportUrl = `${window.location.origin}/report-viewer?access=${encodeURIComponent(accessToken)}`;
    const newTab = window.open(reportUrl, '_blank');
    if (!newTab) {
      setError('Please allow popups to open your report.');
      return;
    }
    newTab.opener = null;

    setIsSubmitting(true);

    try {
      await subscribeEmailToKlaviyo(email);
      setEmail('');
    } catch (requestError) {
      setError(
        requestError instanceof Error
          ? `Your report opened, but Klaviyo subscription failed: ${requestError.message}`
          : 'Your report opened, but Klaviyo subscription failed.'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-[#d9dce4] text-[#111827] min-h-screen">
      <header className="bg-[#F6F6F6] h-[88px] flex items-center justify-center">
        <div className="max-w-[900px] w-full mx-auto px-6 flex justify-center">
          <img src="/images/Logo.webp" alt="The Wealthy Miner" className="h-[78px] w-auto" />
        </div>
      </header>

      <HeroSection />

      <LeadCaptureSection
        email={email}
        isSubmitting={isSubmitting}
        error={error}
        onEmailChange={setEmail}
        onSubmit={submitAndOpenReport}
      />

      <AuthorSection />

      <InsightsSection />

      <FinalCtaSection
        email={email}
        isSubmitting={isSubmitting}
        error={error}
        onEmailChange={setEmail}
        onSubmit={submitAndOpenReport}
      />
    </div>
  );
};

export default MiningReportLanding;
